import { useEffect } from "react";
import Helmet from "react-helmet";
import { useLocation,useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import config from "@/config";
import useCache from "@/hooks/useCache";
import useStateHandler from '@/hooks/useStateHandler';
import HomeNavigation from "@/shared-components/home/components/HomeNavigation";
import Loader from "@/shared-components/loader/Loader";
import AppNavigationPage from "@/shared-components/wrappers/components/AppNavigationPage";

import ArtworkOfTheDay from "./components/ArtworkOfTheDay";
import HomeBanner from "./components/HomeBanner";
import HomeLinks from "./components/HomeLinks";
import HomeSlider from "./components/HomeSlider";

// import StoryTold from './components/StoryTold';
import "./index.css";

function HomeContent({ fetchData }) {
  const navigate = useNavigate();

  const banner_info = {
    "suarte-world": {
      mobileImage: "ef83cebc-900f-4c21-c026-139323687500",
      desktopImage: "6c2636e2-f5f5-4dfc-4158-299dca1a7f00",
      url: "suarteworld",
      alt: "Dive into Suarteworld' with a stylized font that fades from yellow to purple on a dark and galactic background. Enters the infinite artworks scroll."
    },
    "limited-editions": {
      mobileImage: "4834abfe-6362-449b-cbd0-63a1c4548300",
      desktopImage: "5166fcee-d4c7-48e8-0bfa-0ab589bcdd00",
      url: "limited-editions",
      alt: "Limited Editions banner featuring a prominent 'LE' emblem in Suarte's yellow theme tone, with a count of '1/250'.Contains a 'View all' button on the right. Banner invites the viewer to 'Feel the connection and expand your collection with Limited Editions."
    },
    rankings: {
      mobileImage: "3fbe9367-dffd-4854-51c5-a9ea44a36500",
      desktopImage: "7dd32638-303b-4fb5-e50f-a0608be07a00",
      url: "rankings",
      alt: "Rankings banner with dynamic leaderboards for galleries artist and art colectors. The text reads 'Dynamic leaderboards that show la crème de la crème. Are you ready? Share now to unlock Rankings!' Contains a 'Go to Rankings' button."

    },
  };

  return (
    <>
      {fetchData.collections.map((slider) =>
        slider.collection_id === "masterpiece-of-the-day" ? (
          <ArtworkOfTheDay key={slider.collection_id} collectionData={slider} />
        ) : slider.banner === true ? (
          
          <Link key={slider.collection_id} to={{ pathname: `/${banner_info[slider.collection_id].url}`,state: { from: true } }}>
            <HomeBanner
              mobileImage={banner_info[slider.collection_id].mobileImage}
              desktopImage={banner_info[slider.collection_id].desktopImage}
              alt={banner_info[slider.collection_id].alt}
              onClick={() =>
                navigate(`/${banner_info[slider.collection_id].url}`, {
                  state: { from: true },
                })
              
              }
            />
          </Link>
        ) : (
          <HomeSlider
            key={slider.collection_id}
            artworks={slider.collection_artworks}
            category={slider.collection_name}
            endpoint={`/category/${slider.collection_id}?`}
            total={slider.total}
            link={slider.collection_url}
          />
        )
      )}
    </>
  );
}

export default function HomeDiscover({ showAuthPopup = false, authPopUpPage = "" }) {
  const { state, stateHandler } = useStateHandler();
  const location = useLocation();
  const navigate = useNavigate();

  const { loading, fetchData } = useCache(
    `home_discover`,
    `${config.apis.api.url}/home/${window.innerWidth<=550}`,
    {
      expiresIn: ["10", "minutes"],
    }
  );
  
  useEffect(() => {
    // if it is login or signup page
    if(showAuthPopup && authPopUpPage) {
      // and we are not logged in
      if(!state.user_session) {
        stateHandler.set("showAuthPopup", authPopUpPage); 
      } else {
        navigate('/', { replace: true });
      }
    }
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>Suarte | Buy art from galleries worldwide</title>
        <meta
          name="description"
          content="The social art sales platform. Buy original paintings and wall sculptures online from art galleries worldwide. Register today and experience contemporary and modern fine art in the most transparent marketplace, connecting with a community of art lovers. Discover your gateway to the art world and start or keep growing your collection with ease. "
          data-react-helmet="true"
        />
        <meta
          name="keywords"
          content="Paintings, wall sculptures, buy paintings, art galleries, buy art online, art marketplace, art website, fine art"
        />
        <link rel='canonical' href='https://suarte.art' />
      </Helmet>
      <AppNavigationPage>
        <div className="home-discover__page">
          <HomeNavigation active="discover" />

          <HomeLinks />

          {loading ? <Loader /> : <HomeContent fetchData={fetchData} />}
        </div>
      </AppNavigationPage>
    </>
  );
}
